console.log('CARD-PRODUCT SCRIPT STARTED for product {{ card_product.id }} in section {{ section_id }}');
  
(function() {
  // Create a unique identifier for this card instance
  const cardUniqueId = 'card-{{ section_id }}-{{ card_product.id }}';
  
  console.log('CARD-PRODUCT SCRIPT: Unique ID created:', cardUniqueId);
  
  // Add a unique data attribute to the card wrapper for easy targeting
  function markCardWrapper() {
    // Try multiple strategies to find the card wrapper
    
    // Strategy 1: Look for product links with our product ID
    const productLinks = document.querySelectorAll(`[znt-data-product-id="{{ card_product.id }}"]`);
    console.log(`Card {{ card_product.id }}: Found ${productLinks.length} product links`);
    
    for (let link of productLinks) {
      const cardWrapper = link.closest('.card-wrapper');
      if (cardWrapper && !cardWrapper.hasAttribute('data-card-unique-id')) {
        cardWrapper.setAttribute('data-card-unique-id', cardUniqueId);
        console.log(`Card {{ card_product.id }}: Marked card wrapper with ID ${cardUniqueId}`);
        return cardWrapper;
      }
    }
    
    // Strategy 2: Look for any card wrapper that contains our product ID in any element
    const allCardWrappers = document.querySelectorAll('.card-wrapper');
    for (let cardWrapper of allCardWrappers) {
      const hasProductId = cardWrapper.querySelector(`[znt-data-product-id="{{ card_product.id }}"]`);
      if (hasProductId && !cardWrapper.hasAttribute('data-card-unique-id')) {
        cardWrapper.setAttribute('data-card-unique-id', cardUniqueId);
        console.log(`Card {{ card_product.id }}: Marked card wrapper with ID ${cardUniqueId} (strategy 2)`);
        return cardWrapper;
      }
    }
    
    // Strategy 3: Look for card wrapper by section ID in the URL or ID attributes
    const sectionSpecificCard = document.querySelector(`[id*="{{ section_id }}"][id*="{{ card_product.id }}"]`);
    if (sectionSpecificCard) {
      const cardWrapper = sectionSpecificCard.closest('.card-wrapper');
      if (cardWrapper && !cardWrapper.hasAttribute('data-card-unique-id')) {
        cardWrapper.setAttribute('data-card-unique-id', cardUniqueId);
        console.log(`Card {{ card_product.id }}: Marked card wrapper with ID ${cardUniqueId} (strategy 3)`);
        return cardWrapper;
      }
    }
    
    console.log(`Card {{ card_product.id }}: No unmarked card wrapper found`);
    return null;
  }
  
  function findCardWrapper() {
    // First try to find by our unique ID
    let cardWrapper = document.querySelector(`[data-card-unique-id="${cardUniqueId}"]`);
    if (cardWrapper) return cardWrapper;
    
    // If not found, try to mark it
    return markCardWrapper();
  }
  
  function initializeVariantImageEffects() {
    const cardWrapper = findCardWrapper();
    if (!cardWrapper) return false;
    
    const swatches = cardWrapper.querySelectorAll('.znt-swatch_button');
    const variantImages = cardWrapper.querySelectorAll('.variant-image');
    
    if (swatches.length === 0) return false;
    
    console.log(`Card {{ card_product.id }}: Found ${swatches.length} swatches and ${variantImages.length} variant images`);
    
    // Hide all variant images initially
    variantImages.forEach(img => {
      img.style.display = 'none';
    });

    function showVariantImage(variantId) {
      if (!variantId) return;
      // Hide all variant images first
      variantImages.forEach(img => {
        img.style.display = 'none';
        img.classList.remove('znt--showing');
      });
      // Show the target image
      const targetImage = cardWrapper.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
      if (targetImage) {
        targetImage.style.display = 'block';
        targetImage.classList.add('znt--showing');
      }
    }

    swatches.forEach(swatch => {
      // Remove existing listeners to prevent duplicates
      if (swatch.clickHandler) {
        swatch.removeEventListener('click', swatch.clickHandler);
      }
      if (swatch.keydownHandler) {
        swatch.removeEventListener('keydown', swatch.keydownHandler);
      }
      
      // Add click handler
      swatch.clickHandler = function() {
        const variantId = this.getAttribute('data-variant-id');
        const variantUrl = this.getAttribute('data-variant-url');
        
        // Unpress all buttons in this card only
        swatches.forEach(s => {
          s.setAttribute('aria-pressed', 'false');
          s.classList.remove('znt-color-pressed');
        });
        
        // Press this button
        this.setAttribute('aria-pressed', 'true');
        this.classList.add('znt-color-pressed');
        
        // Show the variant image
        showVariantImage(variantId);
        
        // Update the main product link in this card only
        const productLinks = cardWrapper.querySelectorAll(`.product-main-link[znt-data-product-id="{{ card_product.id }}"]`);
        productLinks.forEach(link => {
          link.href = variantUrl;
        });
      };
      
      swatch.addEventListener('click', swatch.clickHandler);

      // Add keyboard support
      swatch.keydownHandler = function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      };
      
      swatch.addEventListener('keydown', swatch.keydownHandler);
    });
    
    return true;
  }

  function initializeSwatchHoverEffects() {
    const cardWrapper = findCardWrapper();
    if (!cardWrapper) return false;
    
    const swatchButtons = cardWrapper.querySelectorAll('.znt-swatch_button');
    
    if (swatchButtons.length === 0) return false;
    
    swatchButtons.forEach(button => {
      // Remove existing listeners to prevent duplicates
      if (button.mouseenterHandler) {
        button.removeEventListener('mouseenter', button.mouseenterHandler);
      }
      if (button.mouseleaveHandler) {
        button.removeEventListener('mouseleave', button.mouseleaveHandler);
      }
      if (button.focusHandler) {
        button.removeEventListener('focus', button.focusHandler);
      }
      if (button.blurHandler) {
        button.removeEventListener('blur', button.blurHandler);
      }
      
      // Mouse events for hover (visual feedback only)
      button.mouseenterHandler = function() {
        this.classList.add('znt-color-hovered');
      };
      button.addEventListener('mouseenter', button.mouseenterHandler);
      
      button.mouseleaveHandler = function() {
        this.classList.remove('znt-color-hovered');
      };
      button.addEventListener('mouseleave', button.mouseleaveHandler);

      // Focus events
      button.focusHandler = function() {
        this.classList.add('znt-color-focused');
        this.classList.add('znt-color-hovered');
      };
      button.addEventListener('focus', button.focusHandler);
      
      button.blurHandler = function() {
        this.classList.remove('znt-color-focused');
        this.classList.remove('znt-color-hovered');
      };
      button.addEventListener('blur', button.blurHandler);
    });

    // ESC key event listener to reset all swatch buttons in this card only
    const escHandler = function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        const cardWrapper = findCardWrapper();
        if (!cardWrapper) return;
        
        const swatchButtons = cardWrapper.querySelectorAll('.znt-swatch_button');
        swatchButtons.forEach(button => {
          button.classList.remove('znt-color-hovered', 'znt-color-focused');
          button.setAttribute('aria-pressed', 'false');
          button.classList.remove('znt-color-pressed');
        });
        
        // Hide all variant images in this card
        const variantImages = cardWrapper.querySelectorAll('.variant-image');
        variantImages.forEach(img => {
          img.classList.remove('znt--showing');
          img.style.display = 'none';
        });
        
        // Restore original product URLs in this card only
        const productLinks = cardWrapper.querySelectorAll('.product-main-link');
        productLinks.forEach(link => {
          const productId = link.getAttribute('znt-data-product-id');
          if (productId) {
            // Get the original URL from any swatch button for this product in THIS CARD ONLY
            const firstSwatch = cardWrapper.querySelector(`.znt-swatch_button[znt-data-product-id="${productId}"]`);
            if (firstSwatch) {
              const originalUrl = firstSwatch.getAttribute('data-original-url');
              link.href = originalUrl;
            }
          }
        });
      }
    };
    
    // Remove existing ESC handler and add new one
    document.removeEventListener('keydown', escHandler);
    document.addEventListener('keydown', escHandler);
    
    return true;
  }

  function initializeCard() {
    // Mark the card wrapper first
    const cardWrapper = markCardWrapper();
    if (!cardWrapper) {
      console.log(`Card {{ card_product.id }}: Could not find card wrapper`);
      return false;
    }
    
    console.log(`Card {{ card_product.id }}: Found card wrapper`, cardWrapper);
    
    // Try to initialize both functions
    const variantSuccess = initializeVariantImageEffects();
    const hoverSuccess = initializeSwatchHoverEffects();
    
    console.log(`Card {{ card_product.id }}: Variant effects: ${variantSuccess}, Hover effects: ${hoverSuccess}`);
    
    return variantSuccess && hoverSuccess;
  }

  function retryInitialization(maxAttempts = 20, delay = 300) {
    let attempts = 0;
    
    function attemptInit() {
      attempts++;
      const success = initializeCard();
      
      if (success) {
        console.log(`Card {{ card_product.id }} initialized successfully`);
        return;
      }
      
      if (attempts < maxAttempts) {
        console.log(`Card {{ card_product.id }} initialization attempt ${attempts} failed, retrying in ${delay}ms...`);
        setTimeout(attemptInit, delay);
      } else {
        console.warn(`Card {{ card_product.id }} failed to initialize after ${maxAttempts} attempts`);
        
        // Final attempt after 10 seconds as a last resort
        console.log(`Card {{ card_product.id }}: Trying final attempt after 10 second timeout...`);
        setTimeout(function() {
          const finalSuccess = initializeCard();
          if (finalSuccess) {
            console.log(`Card {{ card_product.id }} initialized successfully after 10-second timeout`);
          } else {
            console.error(`Card {{ card_product.id }} failed to initialize even after 10-second timeout`);
          }
        }, 10000);
      }
    }
    
    attemptInit();
  }

  // Initialize immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', retryInitialization);
  } else {
    retryInitialization();
  }

  // Also watch for product-recommendations loading
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('product-recommendations--loaded')) {
          // Retry initialization when recommendations are loaded
          setTimeout(retryInitialization, 100);
        }
      }
    });
  });

  // Observe product-recommendations elements
  document.addEventListener('DOMContentLoaded', function() {
    const productRecommendations = document.querySelectorAll('product-recommendations');
    productRecommendations.forEach(function(element) {
      observer.observe(element, { attributes: true });
    });
  });

  // Also observe immediately if DOM is already loaded
  if (document.readyState !== 'loading') {
    const productRecommendations = document.querySelectorAll('product-recommendations');
    productRecommendations.forEach(function(element) {
      observer.observe(element, { attributes: true });
    });
  }
})();

function initializeCardProduct(cardWrapper) {
  const productId = cardWrapper.getAttribute('data-product-id');
  const sectionId = cardWrapper.getAttribute('data-section-id');
  const swatches = cardWrapper.querySelectorAll('.znt-swatch_button');
  const variantImages = cardWrapper.querySelectorAll('.variant-image');

  if (swatches.length === 0) return;

  // Hide all variant images initially
  variantImages.forEach(img => {
    img.style.display = 'none';
  });

  function showVariantImage(variantId) {
    if (!variantId) return;
    variantImages.forEach(img => {
      img.style.display = 'none';
      img.classList.remove('znt--showing');
    });
    const targetImage = cardWrapper.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
    if (targetImage) {
      targetImage.style.display = 'block';
      targetImage.classList.add('znt--showing');
    }
  }

  swatches.forEach(swatch => {
    // Remove existing listeners to prevent duplicates
    if (swatch.clickHandler) {
      swatch.removeEventListener('click', swatch.clickHandler);
    }
    if (swatch.keydownHandler) {
      swatch.removeEventListener('keydown', swatch.keydownHandler);
    }
    if (swatch.mouseenterHandler) {
      swatch.removeEventListener('mouseenter', swatch.mouseenterHandler);
    }
    if (swatch.mouseleaveHandler) {
      swatch.removeEventListener('mouseleave', swatch.mouseleaveHandler);
    }
    if (swatch.focusHandler) {
      swatch.removeEventListener('focus', swatch.focusHandler);
    }
    if (swatch.blurHandler) {
      swatch.removeEventListener('blur', swatch.blurHandler);
    }
    
    // Click handler
    swatch.clickHandler = function() {
      const variantId = this.getAttribute('data-variant-id');
      const variantUrl = this.getAttribute('data-variant-url');
      swatches.forEach(s => {
        s.setAttribute('aria-pressed', 'false');
        s.classList.remove('znt-color-pressed');
      });
      this.setAttribute('aria-pressed', 'true');
      this.classList.add('znt-color-pressed');
      showVariantImage(variantId);
      const productLinks = cardWrapper.querySelectorAll('.product-main-link');
      productLinks.forEach(link => {
        link.href = variantUrl;
      });
    };
    swatch.addEventListener('click', swatch.clickHandler);
    
    // Keyboard handler
    swatch.keydownHandler = function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.click();
      }
    };
    swatch.addEventListener('keydown', swatch.keydownHandler);
    
    // Mouse events for hover (visual feedback only)
    swatch.mouseenterHandler = function() {
      this.classList.add('znt-color-hovered');
    };
    swatch.addEventListener('mouseenter', swatch.mouseenterHandler);
    
    swatch.mouseleaveHandler = function() {
      this.classList.remove('znt-color-hovered');
    };
    swatch.addEventListener('mouseleave', swatch.mouseleaveHandler);

    // Focus events
    swatch.focusHandler = function() {
      this.classList.add('znt-color-focused');
      this.classList.add('znt-color-hovered');
    };
    swatch.addEventListener('focus', swatch.focusHandler);
    
    swatch.blurHandler = function() {
      this.classList.remove('znt-color-focused');
      this.classList.remove('znt-color-hovered');
    };
    swatch.addEventListener('blur', swatch.blurHandler);
  });

  // ESC key handler for this card only
  const escHandler = function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      swatches.forEach(s => {
        s.setAttribute('aria-pressed', 'false');
        s.classList.remove('znt-color-pressed', 'znt-color-hovered', 'znt-color-focused');
      });
      // Hide all variant images in this card
      variantImages.forEach(img => {
        img.classList.remove('znt--showing');
        img.style.display = 'none';
      });
      
      // Restore original product URLs in this card only
      const productLinks = cardWrapper.querySelectorAll('.product-main-link');
      productLinks.forEach(link => {
        const productId = link.getAttribute('znt-data-product-id');
        if (productId) {
          // Get the original URL from any swatch button for this product in THIS CARD ONLY
          const firstSwatch = cardWrapper.querySelector(`.znt-swatch_button[znt-data-product-id="${productId}"]`);
          if (firstSwatch) {
            const originalUrl = firstSwatch.getAttribute('data-original-url');
            link.href = originalUrl;
          }
        }
      });
    }
  };
  
  // Remove existing ESC handler and add new one
  document.removeEventListener('keydown', escHandler);
  document.addEventListener('keydown', escHandler);
}

function initializeAllCardProducts() {
  document.querySelectorAll('.card-wrapper[data-card-unique-id]').forEach(cardWrapper => {
    if (!cardWrapper.hasAttribute('data-swatch-initialized')) {
      initializeCardProduct(cardWrapper);
      cardWrapper.setAttribute('data-swatch-initialized', 'true');
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeAllCardProducts);
document.addEventListener('product-recommendations:loaded', function() {
  initializeAllCardProducts();
});

// Poll every 1s for up to 20s for loaded product recommendations
(function pollForRecommendationsLoaded() {
  let attempts = 0;
  const maxAttempts = 20;
  const interval = setInterval(() => {
    attempts++;
    // Look for loaded recommendations
    const loaded = document.querySelector('.product-recommendations--loaded');
    if (loaded) {
      initializeAllCardProducts();
      clearInterval(interval);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 1000);
})();

